// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2uxYU","footer":"ModalUpdate_footer__1hvDm"};